import './App.css';
import React from 'react';
import Operateurs from './operateurs.js';
import ListDevis from './listDevis.js';
import TabBar from './tabBar.js'
import LoginBox from './loginBox.js'
import FrontOverlay from './frontOverlay';
import Sponsors from './sponsors.js';
import api from './apiConnector'
import CookiesUploader from './cookiesUploader.js';

class App extends React.Component {
    
  constructor(props) {
      super(props);
      this.state = {
          tab:'Devis',
          login:false,
          operator:false,
          searchName:'',
          filterName:'',
          searchTelephone:'',
          searchApporteur:[],
          filterTelephone:'',
          searchSelf:false,
          searchStatus:[],
          searchStatusProcess:[],
          searchNoSolly:true,
          searchAffiliateOnly:false,
          searchAssureur:'',
          searchAssureurOrigin:'',
          startDate:0,
          endDate:0,
          startDateModif:0,
          endDateModif:0,
          dateType:'creation',
          searchUser:[],
          searchUnvalidated:false,
          increment:0,
          axaStatus:'[]',
          axaFirstAlive:0,
          axaLastAlive:0,
          axaNLogin:0,
          axaNWorkers:1,
          axaAlive:false
      }
      api.handlerOnConnectedStatus( this.onConnectedStatus.bind(this) )
      this.mounted = false
  }

  componentDidMount() {
    this.mounted = true
    api.registerEnableView(this)
    api.post(
        {action:'get_status'},
        ()=>{}
    )
  }

  componentWillUnmount() {
      api.unregisterEnableView(this)
  }
  
  setAxaLogout( status ) {
    this.setState({axaStatus:status})
  }

  setAxaAlive( alive ) {
    this.setState({axaAlive:alive})
  }

  setSearchSelf( e ) {
    this.setState({searchSelf:e.target.checked})
  }

  setSearchUnvalidated( e ) {
    this.setState({searchUnvalidated:e.target.checked})
  }

  setDateType( e ) {
    this.setState({dateType:e.target.value})
  }

  setSearchStatus( e ) {
    this.setState({searchStatus:e})
  }

  setSearchStatusProcess( e ) {
    this.setState({searchStatusProcess:e})
  }

  setSearchApporteur( e ) {
    this.setState({searchApporteur:e})
  }

  setStartDate( date ) {
    this.setState({startDate:date})
  }

  setEndDate( date ) {
    this.setState({endDate:date})
  }


  setStartDateModif( date ) {
    this.setState({startDateModif:date})
  }

  setEndDateModif( date ) {
    this.setState({endDateModif:date})
  }

  setSearchUser( e ) {
    this.setState({searchUser:e.map( entry => entry.value )})
  }

  setSearchNoSolly( e ) {
    this.setState({searchNoSolly:e.target.checked})
  }

  setSearchAssureur( e ) {
    this.setState({searchAssureur:e.value })
  }

  setSearchAssureurOrigin( e ) {
    this.setState({searchAssureurOrigin:e.value})
  }

  setSearchAffiliateOnly( e ) {
    this.setState({searchAffiliateOnly:e.target.checked})
  }

  onFilter() {
    this.setState({
      filterName:this.state.searchName,
      filterTelephone:this.state.searchTelephone
    })
  }

  renderContent() {
      switch ( this.state.tab ) {
          case 'Opérateurs':
            return <Operateurs container={this}/>
          case 'Devis Auto':
            return <ListDevis key={this.state.tab} increment={this.state.increment} container={this} type="auto" operator={this.state.operator} filterName={this.state.filterName} filterTelephone={this.state.filterTelephone} searchSelf={this.state.searchSelf} searchUnvalidated={this.state.searchUnvalidated} searchStatus={this.state.searchStatus} searchAssureur={this.state.searchAssureur} searchAssureurOrigin={this.state.searchAssureurOrigin} searchStatusProcess={this.state.searchStatusProcess} searchUser={this.state.searchUser} searchApporteur={this.state.searchApporteur} searchNoSolly={this.state.searchNoSolly} searchAffiliateOnly={this.state.searchAffiliateOnly} startDate={this.state.startDate} endDate={this.state.endDate} startDateModif={this.state.startDateModif} endDateModif={this.state.endDateModif} dateType={this.state.dateType}/>
          case 'Devis':
            return <ListDevis key={this.state.tab} increment={this.state.increment} container={this} type="moto" operator={this.state.operator} filterName={this.state.filterName} filterTelephone={this.state.filterTelephone} searchSelf={this.state.searchSelf} searchUnvalidated={this.state.searchUnvalidated} searchStatus={this.state.searchStatus} searchAssureur={this.state.searchAssureur} searchAssureurOrigin={this.state.searchAssureurOrigin} searchStatusProcess={this.state.searchStatusProcess} searchUser={this.state.searchUser} searchApporteur={this.state.searchApporteur} searchNoSolly={this.state.searchNoSolly} searchAffiliateOnly={this.state.searchAffiliateOnly} startDate={this.state.startDate} endDate={this.state.endDate} startDateModif={this.state.startDateModif} endDateModif={this.state.endDateModif} dateType={this.state.dateType}/>
          case 'Quotations':
            return <ListDevis key={this.state.tab} increment={this.state.increment} container={this} type="moto" operator={this.state.operator} quotations searchUser={false} searchApporteur={this.state.searchApporteur} startDate={this.state.startDate} endDate={this.state.endDate} searchSelf={this.state.searchSelf}/>
          case 'Quotations auto':
            return <ListDevis key={this.state.tab} increment={this.state.increment} container={this} type="auto" operator={this.state.operator} quotations searchUser={false} searchApporteur={this.state.searchApporteur} startDate={this.state.startDate} endDate={this.state.endDate} searchSelf={this.state.searchSelf}/>
          case 'Affiliés':
            return <Sponsors container={this}/>
          case 'Axa Cookies':
            return <CookiesUploader axaStatus={this.state.axaStatus}/>
      }
      return <span>content</span>
  }

  onConnectedStatus(status,operator) {
      if ( this.mounted ) {
        this.setState({login:status,operator:operator})
        if ( !operator &&(( this.state.tab == 'Opérateurs' )||( this.state.tab == 'Affiliés' ))) {
          this.setState({tab:'Devis'})
        }
      }
  }

  isAdmin() {
      return api.isAdmin()
  }

  setTab(tab) {
      this.setState({tab:tab,increment:this.state.increment+1})
  }

  onLogout() {
    api.disconnect()
  }

  renderTabLogout() {
    return <div className={this.state.axaAlive?'tab_notice green':'tab_notice red'}>{this.state.axaAlive?'✅':'🛇'} AXA</div>
  }

  render() {
      const contentClass = ( this.state.tab == 'Affiliés' )?'content_narrow':'content'
      let tabs = ['Devis']
      if ( this.state.operator ) tabs = ['Quotations','Devis','Quotations auto','Devis Auto','Affiliés','Axa Cookies']
      if ( this.isAdmin() ) tabs = ['Quotations','Devis','Quotations auto','Devis Auto','Affiliés','Opérateurs','Axa Cookies']

      return this.state.login
      ? (<>
        <FrontOverlay operator={this.state.operator}/>
        <div className="container" >
          <TabBar 
            tabs={tabs}
            tab={this.state.tab} 
            setTab={this.setTab.bind(this)} 
          >
            { !! this.state.operator && this.renderTabLogout() }
            <div className='tab_logout' onClick={this.onLogout.bind(this)}>
                {this.state.login} | Se déconnecter
            </div>
          </TabBar>
          <div className={contentClass}>{this.renderContent()}</div>
        </div>
      </>)
      : <LoginBox/>
  }
}

export default App;
